class PlanTabInjector {
  constructor(dropdownSelector, targetSelector, headingText, subsaveSelector) {
    this.dropdownSelector = dropdownSelector;
    this.targetSelector = targetSelector;
    this.headingText = headingText;
    this.subsaveSelector = subsaveSelector;
    this.injected = false;
    this.wrapper = null;
    this.dropdown = null;
    this.tabContainer = null;
    this.previousValue = null;
    this.init();
  }

  init() {
    const observer = new MutationObserver(() => {
      const dropdown = document.querySelector(this.dropdownSelector);
      const container = document.querySelector(this.targetSelector);
      const subsaveElement = document.querySelector(this.subsaveSelector);
      
      if (dropdown && container && dropdown.options.length > 0 && !this.injected) {
        this.dropdown = dropdown;
        this.previousValue = dropdown.value;
        this.createTabs(dropdown, container);
        this.observeSubsaveChanges();
        this.observeDropdownChanges();
        this.monitorValueChanges();
        this.injected = true;
        this.appendShippingNotice(subsaveElement);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  appendShippingNotice(subsaveElement) {
  // Avoid injecting the same message twice
    if (!subsaveElement.querySelector('.custom-shipping-message')) {
      const messageDiv = document.createElement('div');
      messageDiv.className = 'custom-shipping-message';
      messageDiv.innerHTML = `<strong>FREE US shipping,</strong> skip or cancel anytime.`;
      subsaveElement.appendChild(messageDiv);
    }
  }

  createTabs(dropdown, container) {
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'custom-tabs-wrapper';

    const heading = document.createElement('div');
    heading.className = 'custom-tabs-heading';
    heading.textContent = this.headingText;

    this.tabContainer = document.createElement('div');
    this.tabContainer.className = 'custom-tabs';

    Array.from(dropdown.options).forEach(option => {
      const tab = document.createElement('div');
      tab.className = 'custom-tab';
      tab.textContent = option.textContent;
      tab.dataset.value = option.value;

      if (option.selected) {
        tab.classList.add('active');
      }

      tab.addEventListener('click', () => {
        dropdown.value = option.value;
        dropdown.dispatchEvent(new Event('change'));
        this.syncActiveTab(option.value);
      });

      this.tabContainer.appendChild(tab);
    });

    this.wrapper.appendChild(heading);
    this.wrapper.appendChild(this.tabContainer);
    container.appendChild(this.wrapper);

    this.toggleWidgetsActive();
  }

  syncActiveTab(value) {
    const allTabs = this.tabContainer.querySelectorAll('.custom-tab');
    allTabs.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.value === value);
    });
  }

  observeSubsaveChanges() {
    const subsaveInputs = document.querySelectorAll(`${this.subsaveSelector} input`);
    subsaveInputs.forEach(input => {
      input.addEventListener('change', () => this.toggleWidgetsActive());
    });
  }

  observeDropdownChanges() {
    this.dropdown.addEventListener('change', () => {
      this.syncActiveTab(this.dropdown.value);
    });
  }

  monitorValueChanges() {
    setInterval(() => {
      if (this.dropdown && this.dropdown.value !== this.previousValue) {
        this.previousValue = this.dropdown.value;
        this.syncActiveTab(this.dropdown.value);
      }
    }, 300);
  }

  toggleWidgetsActive() {
    const subsaveInput = document.querySelector(`${this.subsaveSelector} input`);
    if (subsaveInput && subsaveInput.checked) {
      this.wrapper.classList.add('widgets-active');
    } else {
      this.wrapper.classList.remove('widgets-active');
    }
  }
}

function initPlanTabInjector() {
  new PlanTabInjector(
    '.rc_widget__option__plans__dropdown',
    '.rc-radio-group__options',
    'Delivery every',
    '.rc_widget__option--subsave'
  );
}

initPlanTabInjector();

document.addEventListener('click', function (e) {
  const target = e.target;
  if (
    target.matches('.item__actions') ||
    target.closest('.item__actions a')
  ) {
    setTimeout(() => {
      initPlanTabInjector();
    }, 300);
  }
});
